import css from 'styled-jsx/css';

const styles = css.global`#blog-list-posts .ctn-home-24 {
  padding-top: 32px;
  padding-bottom: 40px;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

#blog-list-posts .blog-list-card {
  max-width: 287px;
  display: flex;
  height: 348px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid #CCC;
  background: transparent;
}

#blog-list-posts .blog-list-card picture{
  width: 285px;
  height: 189px;
  border-radius: 4px;
}

#blog-list-posts .blog-list-card .blog-list-img {
  width: 100%;
  height: 189px;
  border-radius: 4px;
  object-fit: cover;
}

#blog-list-posts .blog-list-card .blog-list-card-conteudos {
  padding: 0 16px 10px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 148px;
}

#blog-list-posts .blog-list-card .blog-list-card-conteudos .title {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

#blog-list-posts .blog-list-card .blog-list-card-conteudos .saibamais {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
}


@media (min-width: 992px) {
  #blog-list-posts .ctn-home-24 {
    padding-top: 40px;
    padding-bottom: 24px;
    gap: 16px 32px;
  }
    
  #blog-list-posts .blog-list-card {
    max-width: 379px;
    height: 369px;
  }

  #blog-list-posts .blog-list-card picture{
    width: 377px;
  }
}

@media (min-width: 1280px) {
  #blog-list-posts .ctn-home-24 {
    justify-content: initial;
  }
}




/* .blog-list-img {
  height: auto;
  width: 100%;
  max-width: 300px;
  object-fit: cover;
}

#blog-list-posts div {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
#blog-list-posts div a {
  cursor: pointer;
  margin-top: 37px;
  color: #444444;
  display: flex;
  flex-direction: column;
  max-width: 288px;
  border-radius: 4px;
border: 1px solid var(--black-cccccc, #CCC);
}

#blog-list-posts p {
  margin: 0;
}

#blog-list-posts span.categorie {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin: 14px 0 0;
  color: currentcolor;
}

#blog-list-posts h2.title {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 33px;
  margin: 7px 0 0;
  color: #444444;
}

#blog-list-posts p.subtitle {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin: 8px 0 0;
}

#blog-list-posts u.saibamais {
  color: #cc0000;
  font-family: 'SantanderText';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-decoration: underline;
  margin: 21px 0 0;
}

@media (min-width: 768px) {
  .blog-list-img {
    max-width: 350px;
    height: 215px;
  }

  #blog-list-posts div {
    justify-content: space-between;
  }

  #blog-list-posts div a {
    max-width: 350px;
    width: 100%;
    position: relative;
    height: 590px;
  }

  #blog-list-posts div a:hover {
    border-color: #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 8px -2px rgb(34 34 34 / 40%);
    background-color: #fff;
    -webkit-transform: scale(1.015);
    -ms-transform: scale(1.015);
    transform: scale(1.015);
  }

  #blog-list-posts p,
  #blog-list-posts u,
  #blog-list-posts span,
  #blog-list-posts h2{
    padding-right: 14px;
    padding-left: 14px;
  }
  #blog-list-posts u.saibamais{
    position: absolute;
    bottom: 14px;
  }
}

.inset {
  background: transparent;
  opacity: 0;
  visibility: visible;
  display: block;
  height: 1px;
  width: 350px;
} */
`;

export default styles;